<script lang="ts">
	import { page } from '$app/state';
	import Link from '$lib/components/atoms/link/Link.svelte';
	import Icon from '$lib/components/icons/Icon.svelte';
	import * as m from '$paraglide/messages';

	const userSession = $derived(page.data.userSession);

	const form = [
		{
			label: m.profile__tabs__information__form__name(),
			value: userSession?.user.name,
		},
		{
			label: m.profile__tabs__information__form__email(),
			value: userSession?.user?.email,
		},
		{
			label: m.profile__tabs__information__form__password(),
			value: '••••••••',
		},
	];
</script>

<div class="flex flex-col gap-8 px-2 items-start w-full">
	<h1 class="text-title text-coloredneutral hidden md:block my-0">
		{m.profile__tabs__information__title()}
	</h1>
	<div class="w-full">
		{#each form as field (field.label)}
			<div class="border-b border-b-solid border-neutral-soft flex flex-col md:flex-row py-3">
				<div class="h-11 md:max-w-60 text-sm text-coloredneutral flex items-center w-full">
					{field.label}
				</div>
				<div
					class="h-11 md:max-w-80 flex items-center text-md p-2 rd-1 bg-neutral-soft text-neutral b-0 cursor-default w-full"
					data-mouseflow-masked-content
				>
					{field.value}
				</div>
			</div>
		{/each}
	</div>
	<div class="flex flex-col gap-2 items-start">
		<div class="flex flex-row items-center gap-1 bg-neutral-soft rd-1 text-coloredneutral p-2">
			<Icon icon="info" class="shrink-0" />
			<span class="text-sm">{m.profile__tabs__information__banner()}</span>
		</div>
		<div>
			<!-- This href will change when we integrate the disconnect page, so we can remove the '?' -->
			{#if userSession?.profile_link}
				<Link
					label={m.profile__tabs__information__modify()}
					icon="edit"
					size="md"
					button="outline"
					href={userSession?.profile_link}
					target="_blank"
					rel="external"
				/>
			{/if}
		</div>
	</div>
</div>
